import {useEffect} from 'react';

const PageTitle = ({
    title
}) => {
    useEffect(() => {
        document.title = title + " - BVÖ Bildungsberatung & Vermittlungsagentur GmbH";

        return () => {
            document.title = title + " - BVÖ Bildungsberatung & Vermittlungsagentur GmbH";
        };
    }, [title]);
};

export default PageTitle;